/*
 * După un deploy, o pagină deja deschisă cere în continuare bucăți de cod cu numele din
 * build-ul vechi. Vite anunță eșecul prin `vite:preloadError`, iar o reîncărcare aduce
 * versiunea nouă. Cel mult o dată pe minut: un fișier care lipsește și după reîncărcare nu
 * are voie să ducă la o buclă.
 */

const KEY = 'rba_preload_reload_at';
const MIN_INTERVAL_MS = 60000;

export function reloadOnPreloadError() {
    window.addEventListener('vite:preloadError', (event) => {
        let last = 0;

        try {
            last = Number(sessionStorage.getItem(KEY)) || 0;
        } catch (error) {
            // sessionStorage blocat: fără gardă, deci nici reîncărcare automată.
            return;
        }

        if (Date.now() - last < MIN_INTERVAL_MS) {
            return;
        }

        event.preventDefault();

        try {
            sessionStorage.setItem(KEY, String(Date.now()));
        } catch (error) {
            return;
        }

        window.location.reload();
    });
}
